<div *ngIf="currentUser">
  <p>Bandwidth status: <b><span style="color: #007bff">{{ currentUser.company.sugarMckayStatus }}</span></b></p>
  <br>
  <div style="width: 70%;">
    <p-table [value]="schedules">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 35%">Mckay Schedules</th>
          <th>Type</th>
          <th>Service start date</th>
          <th>Current term end date</th>
        </tr>
      </ng-template>
      <ng-template let-schedule pTemplate="body">
        <tr>
          <td style="width: 35%">{{ schedule.name }}</td>
          <td>{{ schedule.bundleName }}</td>
          <td>{{ schedule.initialTermStartDate | date: "MMM dd, y" }}</td>
          <td>{{ schedule.initialTermEndDate | date: "MMM dd, y" }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        {{ schedules?.length }} schedules
      </ng-template>
    </p-table>
  </div>
</div>
